var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapLocator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.007,
    height: 16,
    viewBox: "0 0 11.007 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#477aff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-76.998)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M82.5,0A5.5,5.5,0,0,0,77,5.5c0,2.317,3.2,7.657,4.719,10.064a.928.928,0,0,0,1.569,0C84.807,13.16,88.005,7.822,88.005,5.5A5.5,5.5,0,0,0,82.5,0Zm0,8.865a3.113,3.113,0,1,1,3.113-3.113A3.113,3.113,0,0,1,82.5,8.865Z",
    transform: "translate(0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapLocator);
export default __webpack_public_path__ + "static/media/map-locator.5e3396e3.svg";
export { ForwardRef as ReactComponent };